import { typedPath } from "typed-path";
import { useFormikContext } from "formik";
import lodashGet from "lodash/get";

/**
 * helper type for a typed-path object which refers to an object of type T.
 */
export type TypedPathTo<T> = ReturnType<typeof typedPath<T>>;

export function useFormikValuesAtBasePath<T>(basePath: TypedPathTo<T>): T {
  const { values } = useFormikContext();

  if (basePath.$path === "") {
    // an empty base path string means "the root object"; lodash get doesn't
    // behave correctly for this use case, so do the right thing
    return values as T;
  } else {
    return lodashGet(values, basePath.$path) as T;
  }
}
